import logo from './logo.svg';
import './App.css';
import store from './store';
import {Provider} from 'react-redux';
import Navheader from './Components/Navheader';
import Background from './Components/Background';
import Element from './Components/Element';
import styles from './Components/styles.module.scss';
import Button from './Components/Button';
import Card from './Components/Card';
import Footer from './Components/Footer';
import Vid from './Components/Vid';
import PasswordInput from './Components/PasswordInput';
import Modal from './Components/Modal';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';


function Playing(props) {
  const gameArray = props.games;
  const gameCardsArray = props.gameCards;
   const horrorGameArray = props.horrorGames;
  const {id} = useParams();
  console.log(id);
  let realId = parseInt(id[1]);
  const navigate = useNavigate();

  useEffect(() => {
    if(realId == 5){
   setInterval(()=>{
 const exitValue = localStorage.getItem("exit");
    if (exitValue !== null && exitValue === "1") {
      navigate('/games/:5');
      localStorage.setItem("exit","0");
    }
    },200);
    }
 
   
  }, [navigate]);
  return (

    <div className="App"
    style={{
      width: '100%',
      background:'black',
      overflowX: "hidden"
    }}>
    <Background halloween={props.halloween} xmas={props.xmas}></Background> 
        {realId != 5 &&<Element halloween={props.halloween} xmas={props.xmas} height={"10P"} background={2}></Element>}
   {realId != 5 && <Element halloween={props.halloween} xmas={props.xmas} height={"90P"} background={10} flexColumn={true} style={{overflowY: 'hidden'}}>
    {realId == 4 && <iframe className={`${styles[`iframe`]} ${styles[`iframe--full`]} ${styles[`iframe--rpgmaker`]}`} src='/www/index.html'>

    </iframe>}
        {realId == 6 && <iframe className={`${styles[`iframe`]} ${styles[`iframe--full`]} ${styles[`iframe--rpgmaker`]}`} src='/www2/index.html'>

    </iframe>}
    </Element>}
{realId == 5 &&<Element halloween={props.halloween} xmas={props.xmas} height={"100P"} background={9} flexColumn={true}>
   <iframe className={`${styles[`iframe`]} ${styles[`iframe--full`]}`} src='/night/index.html'>

    </iframe> 

</Element>}
   

       
                        
                                 
        {/* {realId != 5 &&<Footer></Footer>} */}

        

    {realId != 5 && <Navheader halloween={props.halloween} xmas={props.xmas} games={gameArray} horrorGames={horrorGameArray}></Navheader>}
   
    </div>

    
  );
}

export default Playing;
